import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { workflowLWDsApi } from './workflowLWDsSlice';
import { throwErrorMessage } from 'helpers/functions/errors';
import { getOAuth2StartUrl } from 'utils/oauth';

interface ApiErrorData {
    message?: string;
    detail?: string;
    title?: string;
    errors?: any[] | string;
    errorString?: string;
}

interface QueryErrorPayload {
    status?: number;
    originalStatus?: number;
    data?: ApiErrorData;
}

export const workflowLWDApiQueryErrorLogger: Middleware = () => next => (action: any) => {
    if (isRejectedWithValue(action) && action.type.startsWith(workflowLWDsApi.reducerPath)) {
        const payload = action.payload as QueryErrorPayload;
        const status = payload.originalStatus || payload.status;

        switch (status) {
            case 400:
                let errorMessage = 'Bad Request';
                const payloadData = payload.data;

                if (payloadData) {
                    if (Array.isArray(payloadData.errors) && payloadData.errors.length > 0) {
                        const firstError = payloadData.errors[0];
                        errorMessage = firstError?.ErrorMessage || firstError?.message || firstError;
                    } else if (payloadData.message) {
                        errorMessage = payloadData.message;
                    } else if (payloadData.detail) {
                        errorMessage = payloadData.detail;
                    } else if (typeof payloadData === 'string') {
                        errorMessage = payloadData;
                    }
                }

                throwErrorMessage(400, action, errorMessage);
                break;

            case 401:
                throwErrorMessage(401, action, 'Error Code: 401. Unauthorized');
                location.replace(getOAuth2StartUrl());
                break;

            case 403:
                const endpoint = (action.meta as any)?.arg?.endpointName;
                console.warn(`Type: ${action.type}`);
                console.warn(`We got a rejected action in API! (403) - ${endpoint}`);
                console.warn(payload);
                break;

            case 404:
                throwErrorMessage(404, action, `${payload.data?.title ?? 'Error Code 404'}`);
                break;

            case 409:
                throwErrorMessage(409, action, 'Error Code 409');
                break;

            default:
                const defaultError = payload.data?.errors ?? payload.data?.message ?? 'Internal Server Error';
                throwErrorMessage(500, action, `${defaultError}`);
                break;
        }
    }

    return next(action);
};
